import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";

class PrivateRoute extends Component {

  render() {
    let { component: RouteComponent, ...otherProps } = this.props;
    return (

      <Route {...otherProps} render={props => (
        this.props.auth && this.props.auth.access_token ? (
          <RouteComponent {...props} />
        ) : (
            <Redirect to={{
              pathname: '/login',
              state: { from: props.location }
            }} />
          )
      )} />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})
export default connect(
  (state) => ({ auth: state.auth }),
  mapDispatchToProps
)(PrivateRoute);
